import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { AuthService } from '../../services/auth.service';

import { Router } from '@angular/router';

import { CommonModule } from '@angular/common';

import { NgbActiveModal, NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    NgbDropdown,
    NgbDropdownMenu,
    NgbDropdownItem,
    NgbDropdownToggle
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit {

  public user: any = null;
  public userSymbol = '';

  constructor(private apiService: ApiService, private authService: AuthService, private router: Router) {
  }

  ngOnInit(): void {
    const self = this;

    self.apiService.get("/me").then((data: any) => {
      self.user = data;

      if (data['name']) {
        self.userSymbol = data['name'].substring(0, 1).toUpperCase();
      }
    });
  }

  openProfile() {
    this.router.navigate(['profile']);
  }

  logout() {
    this.authService.logout();
    setTimeout(() => {
      window.location.reload();
    }, 100);
  }
}
